// removed by extract-text-webpack-plugin
module.exports = {"Logo":"Logo__Logo__3nkm4","image":"Logo__image__1mK0A"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/Logo.scss
// module id = 230
// module chunks = 0